// Fonctions utilitaires pour les types de ressources pédagogiques

export const getResourceLogo = (type) => {
	const resourceTypes = {
		'PACKAGE': '/img/type-expresso.png',
		'ACTIVITY': '/img/type-flash.png',
		'Activité rituelle': '/img/type-flash.png',
		'ExerciseSheet': '/img/type-qcm.png',
		'EXERCISE_SHEET': '/img/type-qcm.png',
		'EVALUATION': '/img/type-qcm.png',
		'Evaluation': '/img/type-qcm.png',
		'Game': '/img/type-game.png',
		'Calendrier de l\'Avent': '/img/type-game.png',
		'TileGame': '/img/type-game.png',
		'QCM': '/img/type-qcm.png',
		'Leçon': '/img/file.png'
	};
	
	return resourceTypes[type] || '/img/file.png';
};

export const getResourceTypeName = (type) => {
	const resourceTypeNames = {
		'PACKAGE': 'Activités expresso',
		'ACTIVITY': 'Questions flash',
		'Activité rituelle': 'Questions flash',
		'ExerciseSheet': 'Exercices',
		'EXERCISE_SHEET': 'Exercices',
		'EVALUATION': 'Évaluation',
		'Evaluation': 'Évaluation',
		'Game': 'Jeu sérieux',
		'Calendrier de l\'Avent': 'Jeu sérieux',
		'TileGame': 'Jeu sérieux',
		'QCM': 'QCM',
		'Leçon': 'Leçon'
	};
	
	return resourceTypeNames[type] || type;
};

// Fonction pour obtenir toutes les informations d'un type de ressource
export const getResourceInfo = (type) => {
	return {
		logo: getResourceLogo(type),
		name: getResourceTypeName(type),
		type: type
	};
};

// Constantes pour les types de ressources
export const RESOURCE_TYPES = {
	PACKAGE: 'PACKAGE',
	ACTIVITY: 'ACTIVITY',
	ACTIVITY_RITUAL: 'Activité rituelle',
	EXERCISE_SHEET: 'ExerciseSheet',
	EXERCISE_SHEET_CAPS: 'EXERCISE_SHEET',
	EVALUATION: 'EVALUATION',
	EVALUATION_LOWER: 'Evaluation',
	GAME: 'Game',
	CHRISTMAS_CALENDAR: 'Calendrier de l\'Avent',
	TILE_GAME: 'TileGame',
	QCM: 'QCM',
	LESSON: 'Leçon'
};
